import { createContext, useContext, useState, type ReactNode } from "react";

interface ScopeState {
  /** null = all clients; otherwise a client id. */
  client: string | null;
  setClient: (c: string | null) => void;
}

const ScopeContext = createContext<ScopeState | null>(null);

export function ScopeProvider({ children }: { children: ReactNode }) {
  const [client, setClient] = useState<string | null>(null);
  return <ScopeContext.Provider value={{ client, setClient }}>{children}</ScopeContext.Provider>;
}

export function useScope(): ScopeState {
  const ctx = useContext(ScopeContext);
  if (!ctx) throw new Error("useScope must be used within ScopeProvider");
  return ctx;
}
